import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import classnames from "classnames";
import ReCAPTCHA from "react-google-recaptcha";
import rxconnexionLogo from "../../utils/rxconnexionLogo.png";
import secureBadge from "../../utils/secureBadge.png";
import queryString from "query-string";
import isEmpty from "is-empty";
import $ from "jquery";
import { toast, ToastContainer } from "react-toastify";
import PulseLoader from "react-spinners/PulseLoader";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

var x;
class Login extends Component {
  constructor() {
    super();
    this.state = {
      rx_group: "",
      password: "",
      email: "",
      phone: "",
      isFilterOpen: "email",
      errors: {},
      triggered: false,
      selected: "",
      section: "login",
      loading: false,
      type: "",
      otp: "",
      allowResend: true,
      isVisible: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      if (queryString.parse(window.location.search).goto) {
        if (
          queryString.parse(window.location.search).goto ===
          "subscribe-doorstep"
        ) {
          this.props.history.push("/choose-plan?solution=DoorstepRx");
        } else if (
          queryString.parse(window.location.search).goto ===
          "subscribe-costplus"
        ) {
          this.props.history.push("/choose-plan?solution=Costplus");
        } else if (
          queryString.parse(window.location.search).goto === "subscribe-tabula"
        ) {
          this.props.history.push("/choose-plan?solution=TabulaRx");
        } else if (
          queryString.parse(window.location.search).goto === "subscribe-bona"
        ) {
          this.props.history.push("/choose-plan?solution=BonaRx");
        } else {
          this.props.history.push("/");
        }
      } else {
        this.props.history.push("/");
      }
    } else {
      sessionStorage.removeItem("jwtToken");
    }

    if (queryString.parse(window.location.search).multiple) {
      toast.warning("You have already logged in to other browser", {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      if (
        queryString.parse(window.location.search).solution === "xpedicare24"
      ) {
        confirmAlert({
          title: "Login Required",
          message:
            "To complete your registration for XPedicareRx-24 please log in to your RxConnexion account",
          buttons: [
            {
              label: "Ok",
              onClick: () => {},
              className: "btn btn-large btn-primary mt-2 px-5",
            },
          ],
        });
      }
    }
    $("body").css({ zoom: 1 });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated && !this.state.triggered) {
      this.setState(
        {
          triggered: true,
        },
        () => this.continue()
      );
    }

    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  openModel = () => {
    $(".login-redirect").trigger("click");
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  handleonChange(value) {
    x = value;
  }
  toggleChange = (value) => {
    this.setState({
      isFilterOpen: value,
    });
  };

  onChangeRadio = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (x === undefined) {
      alert("please verify you are not robot");
    } else {
      let { errors } = this.state;
      if (this.state.email === "") {
        errors.email = "This field is required";
      } else {
        delete errors.email;
      }
      if (this.state.password === "") {
        errors.password = "This field is required";
      } else {
        delete errors.password;
      }
      if (isEmpty(errors)) {
        this.setState({ loading: true });
        const userData = {
          password: this.state.password,
        };
        if (this.state.isFilterOpen === "group") {
          userData.rx_group = this.state.rx_group.toUpperCase();
        } else {
          userData.email = this.state.email;
        }
        axios({
          method: "POST",
          url: "/api/login",
          data: userData,
        }).then((res) => {
          if (res.data.success) {
            this.setState({ section: "sendOtp", phone: res.data.phone });
          } else {
            this.setState({ errors: res.data });
          }
          this.setState({ loading: false });
        });
      } else {
        this.setState({ errors, loading: false });
      }

      // this.props.loginUser(userData);
    }
  };

  sendOtp = (e) => {
    e.preventDefault();
    let { errors } = this.state;
    if (this.state.type === "") {
      errors.type = "This field is required";
    } else {
      delete errors.type;
    }
    if (isEmpty(errors)) {
      this.setState({ loading: true, allowResend: false });
      const userData = {
        //   email: "mhariri@smartsrx.com",
        email: this.state.email,
        type: this.state.type,
      };
      axios({
        method: "POST",
        url: "/api/send-otp",
        data: userData,
      }).then((res) => {
        if (res.data.success) {
          this.setState({ section: "verifyOtp", loading: false });
          $("#otp").focus();
          setTimeout(() => {
            this.setState({ allowResend: true });
          }, 10000);
        } else {
          confirmAlert({
            title: "Error",
            message: res.data.message,
            buttons: [
              {
                label: "Ok",
                onClick: () => {
                  this.setState({ otp: "" });
                },
              },
              {
                label: "Cancel",
                onClick: () => {},
              },
            ],
          });
          this.setState({ loading: false });
        }
      });
    } else {
      this.setState({ errors, loading: false });
    }
  };

  verifyOtp = (e) => {
    e.preventDefault();
    let { errors } = this.state;
    if (this.state.otp === "") {
      errors.otp = "This field is required";
    } else {
      delete errors.otp;
    }
    if (isEmpty(errors)) {
      this.setState({ loading: true });
      const userData = {
        // email: "mhariri@smartsrx.com",
        email: this.state.email,
        otp: this.state.otp,
      };
      axios({
        method: "POST",
        url: "/api/verify-otp",
        data: userData,
      }).then((res) => {
        if (res.data.success) {
          this.props.loginUser(res.data.token);
        } else {
          this.setState({ loading: false });
          confirmAlert({
            title: "Error",
            message: res.data.message,
            buttons: [
              {
                label: "Ok",
                onClick: () => {
                  this.setState({ otp: "" });
                },
              },
              {
                label: "Cancel",
                onClick: () => {},
              },
            ],
          });
        }
      });
    } else {
      this.setState({ errors, loading: false });
    }
  };

  continue = () => {
    if (
      queryString.parse(window.location.search).solution &&
      queryString.parse(window.location.search).solution === "XPedicareRx-24"
    ) {
      this.props.history.push(`/card-info?solution=XPedicareRx-24`);
    } else if (this.props.auth.user.login_flow) {
      let solution = this.props.auth.user.solutionFor;
      if (solution && solution !== "") {
        this.props.history.push(
          `/card-info?${
            ["Growth Plan", "Essential Plan", "Premium Plan"].includes(solution)
              ? "plan="
              : "solution="
          }${solution}`
        );
      } else {
        this.props.history.push("/choose-plan");
      }
    } else {
      this.props.history.push("/landing");
    }
  };

  redirectClick = (e) => {
    this.setState({
      selected: e.currentTarget.id,
    });
  };

  resend = () => {
    this.setState({ section: "sendOtp" });
  };

  handlePassword = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  render() {
    const { errors, allowResend, isVisible } = this.state;

    return (
      <div
        className="nam login"
        style={{
          backgroundImage:
            "url(https://rxreachanalytis.s3.amazonaws.com/logo/RxConnexion_Login_Artwork.png)",
        }}
      >
        {this.state.loading && (
          <div className="loading-wrapper">
            <PulseLoader color="#007bff" loading={true} size={20} />
          </div>
        )}

        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div
            className="card shadow p-4"
            style={{
              width: "100%",
              maxWidth: "400px",
              borderRadius: "20px",
            }}
          >
            {this.state.section === "login" && (
              <>
                <div className="text-center mb-3">
                  <img
                    src={rxconnexionLogo}
                    alt="RxConnexion"
                    height={50}
                    width={300}
                  />
                  <h3
                    className="mt-4"
                    style={{
                      color: "#2A3E90",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    Welcome to RxConnexion
                  </h3>
                  {/* <p
                    style={{
                      color: '#2A3E90',
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 600,
                      fontSize: '15px',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                      lineHeight: '1.6',
                    }}
                  >
                    Step 1: Enter your RXConnexion credentials
                  </p> */}
                </div>

                <form noValidate onSubmit={this.onSubmit}>
                  <div className="mb-3">
                    <input
                      type="email"
                      id="email"
                      value={this.state.email}
                      onChange={this.onChange}
                      className={classnames("form-control", {
                        "is-invalid": errors.email,
                      })}
                      placeholder="Email Address"
                    />
                    <div className="invalid-feedback">{errors.email}</div>
                  </div>

                  <div className="mb-3 position-relative">
                    <input
                      type={isVisible ? "text" : "password"}
                      id="password"
                      value={this.state.password}
                      onChange={this.onChange}
                      className={classnames("form-control", {
                        "is-invalid": errors.password,
                      })}
                      placeholder="Password"
                      style={{ paddingRight: "2.5rem" }}
                    />

                    <span
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#aaa",
                      }}
                      onClick={this.handlePassword}
                    >
                      {isVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                    </span>

                    <div className="invalid-feedback">{errors.password}</div>
                  </div>

                  <div className="d-flex justify-content-end mb-3">
                    <Link to="/forgot" className="text-decoration-none small">
                      Reset Password?
                    </Link>
                  </div>

                  {/* <div className="mb-1 text-center">
                    <p
                      style={{
                        color: '#2A3E90',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 600,
                        fontSize: '15px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        lineHeight: '1.6',
                      }}
                    >
                      Step 2:<br />
                      on the next screen you’ll choose to get an OTP<br />
                      via email or phone to login
                    </p>
                  </div> */}

                  <div
                    className="d-grid mb-3"
                    style={{ width: "300px", margin: "0 auto" }}
                  >
                    <ReCAPTCHA
                      sitekey="6Lf03WQdAAAAAFFVuRu8tD3Bk-wOhHO22Tyeotyx"
                      onChange={this.handleonChange}
                    />
                  </div>

                  <div className="d-grid mb-3">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        borderRadius: "10px",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: "14px",
                        padding: "10px 0",
                        width: "350px",
                      }}
                    >
                      Sign In
                    </button>
                  </div>

                  <div className="text-center">
                    <span className="small">Don’t have an account? </span>
                    <Link to="/register" className="text-decoration-none small">
                      Sign Up
                    </Link>
                  </div>

                  <div className="text-center mt-3">
                    <img src={secureBadge} alt="Secure" height={50} />
                  </div>
                </form>
              </>
            )}

            {this.state.section === "sendOtp" && (
              <>
                <div className="text-center mb-3">
                  <img
                    src={rxconnexionLogo}
                    alt="RxConnexion"
                    height={50}
                    width={300}
                  />
                  <h3
                    className="mt-4"
                    style={{
                      color: "#2A3E90",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    OTP Verification
                  </h3>
                  <p
                    style={{
                      color: "#2A3E90",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      fontSize: "15px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      lineHeight: "1.6",
                    }}
                  >
                    To verify your identity, choose to receive an authorization
                    code via email or phone.
                  </p>
                </div>

                <form
                  noValidate
                  onSubmit={this.sendOtp}
                  className="white send-otp"
                >
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      id="email"
                      checked={this.state.type === "email"}
                      onChange={() => this.onChangeRadio("type", "email")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="email"
                      style={{ fontSize: "16px" }}
                    >
                      Email (
                      {this.state.email.replace(
                        /^(.)(.*)(.@.*)$/,
                        (_, a, b, c) => a + b.replace(/./g, "*") + c
                      )}
                      )
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      id="phone"
                      checked={this.state.type === "phone"}
                      onChange={() => this.onChangeRadio("type", "phone")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="phone"
                      style={{ fontSize: "16px" }}
                    >
                      Phone (********{this.state.phone})
                    </label>
                  </div>

                  {(this.state.email === "mehrdadhairi@gmail.com" ||
                    this.state.email === "mhariri@smartsrx.com") && (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="type"
                        id="cole"
                        checked={this.state.type === "cole"}
                        onChange={() => this.onChangeRadio("type", "cole")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="cole"
                        style={{ fontSize: "16px" }}
                      >
                        Phone (********317)
                      </label>
                    </div>
                  )}

                  <div className="text-center mt-3">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        borderRadius: "10px",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: "14px",
                        padding: "10px 30px",
                      }}
                    >
                      Send OTP
                    </button>
                  </div>
                </form>
              </>
            )}

            {this.state.section === "verifyOtp" && (
              <>
                <div className="text-center mb-3">
                  <img
                    src={rxconnexionLogo}
                    alt="RxConnexion"
                    height={50}
                    width={300}
                  />
                  <h3
                    className="mt-4"
                    style={{
                      color: "#2A3E90",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    OTP Verification
                  </h3>
                </div>

                <form noValidate onSubmit={this.verifyOtp} className="white">
                  <div className="mb-3">
                    <input
                      onChange={this.onChange}
                      value={this.state.otp}
                      id="otp"
                      type="text"
                      className={classnames("form-control", {
                        "is-invalid": errors.otp,
                      })}
                      placeholder="Enter OTP"
                    />
                    <div className="invalid-feedback">{errors.otp}</div>
                  </div>

                  {allowResend && (
                    <div className="text-end mb-2">
                      <a
                        href="#"
                        onClick={this.resend}
                        className="small text-decoration-none"
                      >
                        Resend OTP
                      </a>
                    </div>
                  )}

                  <div className="text-center mt-3">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{
                        borderRadius: "10px",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: "14px",
                        padding: "10px 30px",
                      }}
                    >
                      Verify OTP
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>

        <ToastContainer />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});
export default connect(mapStateToProps, { loginUser })(Login);
